
import jQuery from "jquery";
import {ZIDX} from "./standaloneLibrary.js";

let $=jQuery.noConflict();

export class InfiniteScrollOptions{
    // rowMargin:number=0;
    debug:boolean=false;
    containerElement:HTMLDivElement;
    panelContainerElement:HTMLDivElement;
    enableLoadMore:boolean=false;
    // footerElement:HTMLDivElement;
    panelCallbackObj:object;
    panelHeightCallback:string;
    panelRenderCallback:string;
    panelClass:string='';
    count:number=0;
    constructor(containerElement:HTMLDivElement, panelContainerElement:HTMLDivElement,  panelCallbackObj:object, panelHeightCallback:string, panelRenderCallback:string, enableLoadMore:boolean) {
        this.containerElement=containerElement;
        this.panelContainerElement=panelContainerElement;
        this.panelCallbackObj=panelCallbackObj;
        this.panelHeightCallback=panelHeightCallback;
        // this.footerElement=footerElement;
        this.panelRenderCallback=panelRenderCallback;
        this.enableLoadMore=enableLoadMore;
    }
}
export class InfiniteScrollPanel{
    element:HTMLAnchorElement;
    offset:number=0; // position in the panel array
    x:number=0;
    y:number=0;
    rendered:boolean=false;
    visible:boolean=true;

    constructor(element:HTMLAnchorElement) {
        this.element=element;
    }
    destroy(){
        if(this.element && this.element.parentNode) {
            $(this.element).remove();
        }
        this.rendered=false;
    }
    render(html:string){
        $(this.element).html(html);
    }
}

export class InfiniteScroll{
    options:InfiniteScrollOptions;
    // panelDimensionElement:HTMLDivElement;
    panels:InfiniteScrollPanel[]=[];
    // panelDimensions:DOMRect;
    // startVisibleIndex:number=0;
    // endVisibleIndex:number=0;
    // columnCount:number=1;
    resultLimit:number=2000; // prevent more than 2000 because c++ app limits for performance
    // rowHeight:number=0;
    // containerPosition:DOMRect;
    // footerPosition:DOMRect;
    // panelContainerPosition:DOMRect;
    loadPerPage:number=12;
    loadedCount:number=this.loadPerPage;
    zidx:ZIDX;
    constructor(props:InfiniteScrollOptions, zidx:ZIDX) {
        this.zidx=zidx;
        this.options=props;
        // this.containerPosition=this.options.containerElement.getBoundingClientRect();
        // this.panelContainerPosition = this.options.panelContainerElement.getBoundingClientRect();
        // let divTest=this.zidx.peakidxShadowRoot.getElementById("zidxPanelDimensionTest");
        // this.footerPosition=this.options.footerElement.getBoundingClientRect();
        $(".zidxLoadMoreButton", this.zidx.peakidxShadowRoot).off().on("click", (e:Event)=> {
            e.preventDefault();
            // console.log("load more clicked", this.options.count, this.loadedCount);
            this.loadedCount+=this.loadPerPage;
            this.update();
        });
        // if(divTest==null) {
        //     this.panelDimensionElement = document.createElement("div");
        //     this.panelDimensionElement.id = "zidxPanelDimensionTest";
        //     this.panelDimensionElement.className = this.options.panelClass;
        //     this.panelDimensionElement.style.zIndex = "1";
        //     this.panelDimensionElement.style.position="absolute !important";
        //     this.panelDimensionElement.style.left = "-1000px !important";
        //     this.panelDimensionElement.style.top = "-1000px !important";
        //     this.options.panelContainerElement.appendChild(this.panelDimensionElement);
        // }else{
        //     this.panelDimensionElement=<HTMLDivElement>divTest;
        // }
        // this.panelDimensions=this.panelDimensionElement.getBoundingClientRect();
        // this.getPanelDimensions();
        // this.areVisiblePanelsChanged();
        this.updatePanels();
        let self=this;
        // $(window).on("clientresize resize", function(){
        //     let position=self.options.containerElement.getBoundingClientRect();
        //     if(position.width==0){
        //         return;
        //     }
        //     self.resize();
        // });
        // $(this.options.containerElement).on("mousedown touchstart", function() {
        //     if(typeof window.ZWIXAppScroll!="undefined") {
        //         window.Wix.scrollTo(0, window.ZWIXAppScroll.y-window.ZWIXBannerOffset);
        //     }
        // });
        // $(this.options.containerElement).on("scroll wheel", function(){
        //     let position=self.options.containerElement.getBoundingClientRect();
        //     if(position.width==0){
        //         return;
        //     }
        //     self.update();
        // })
    }
    // updatePanelsVisibility(){
    //     this.containerPosition=this.options.containerElement.getBoundingClientRect();
    //     for(let i in this.panels) {
    //         let panel = this.panels[i];
    //         this.updatePanelVisibility(panel);
    //     }
    // }
    // updatePanelVisibility(panel:InfiniteScrollPanel){
    //     if(!panel.element) return;
    //     let position = panel.element.getBoundingClientRect();
    //     if(this.options.enableLoadMore || position.top<=this.containerPosition.bottom && position.bottom+this.options.containerElement.scrollTop>=this.options.containerElement.scrollTop){
    //         let $panelElement=$(".zidxImageNotLoaded", panel.element);
    //         panel.visible=true;
    //         if($panelElement.length>0) {
    //             $($panelElement[0]).attr("style", this.zidx.getListingBackgroundImageCSS($panelElement.attr("data-image")!, true));
    //             $panelElement.removeClass("zidxImageNotLoaded");
    //         }
    //     }else{
    //         panel.visible=false;
    //     }
    // }
    // getPanelDimensions(){
    //     // console.log("this.options.containerElement:", this.options.containerElement);
    //     // console.log("this.options.panelContainerElement:", this.options.panelContainerElement);
    //     // console.log("this.panelDimensionElement:", this.panelDimensionElement);
    //     this.containerPosition=this.options.containerElement.getBoundingClientRect();
    //     if(this.options.debug) console.log("containerPosition:", this.containerPosition);
    //     // this.options.panelContainerElement.style.width=Math.floor(this.containerPosition.width)+"px";
    //     this.panelDimensions=this.panelDimensionElement.getBoundingClientRect();
    //     // @ts-ignore
    //     let panelHeight=this.options.panelCallbackObj[this.options.panelHeightCallback](this.panelDimensions);
    //     // console.log("panelHeight:", panelHeight);
    //     // can't do this on ie11 in strict mode
    //     // this.panelDimensions.height=panelHeight;
    //     if(this.options.debug) console.log("panelDimensions (it's ok that height is 0:", this.panelDimensions);
    //     this.panelContainerPosition=this.options.panelContainerElement.getBoundingClientRect();
    //     this.columnCount=Math.floor(this.panelContainerPosition.width/this.panelDimensions.width);
    //     if(this.options.debug) console.log("this.columnCount:",this.columnCount);
    //     let marginPixels=this.panelContainerPosition.width%this.panelDimensions.width;
    //     let rowMargin=0;
    //     if(this.columnCount>1){
    //         rowMargin=Math.round(marginPixels/(this.columnCount-1));
    //     }
    //     // rowMargin=0;
    //     this.rowHeight=panelHeight+rowMargin;
    //     let containerHeight=Math.round(Math.ceil(Math.min(this.resultLimit, this.options.count)/this.columnCount)*this.rowHeight);
    //     if(this.options.enableLoadMore) {
    //         containerHeight=this.rowHeight*(this.loadedCount/3);
    //         this.options.footerElement.style.display="none";
    //         $(".zidxFooterDisclaimerContainer", this.zidx.peakidxShadowRoot).css("display", "block");
    //     }else{
    //     }
    //
    //     this.options.footerElement.style.top=containerHeight+"px";
    //     containerHeight+=this.footerPosition.height+rowMargin;
    //     // console.log("scroller height",this.rowHeight, this.columnCount, this.loadedCount,  Math.ceil(Math.min(this.resultLimit, this.loadedCount)/this.columnCount));
    //     containerHeight=(this.rowHeight*Math.ceil(Math.min(this.resultLimit, this.loadedCount)/this.columnCount));
    //     this.options.footerElement.style.left="0px";
    //
    //     if(this.options.debug) console.log("rowMargin:", rowMargin, "rowHeight:", this.rowHeight);
    //     // if(!this.zidx.options.wixApp) {
    //     if(this.options.enableLoadMore) {
    //         // TODO enableLoadMore
    //         // this.panelDimensionElement.style.display="block !important";
    //         // this.panelDimensionElement.style.left = "100px !important";
    //         // this.panelDimensionElement.style.top = "100px !important";
    //         this.panelDimensions=this.panelDimensionElement.getBoundingClientRect();
    //         // console.log("enableLoadMore this.panelDimensions", this.panelDimensionElement, this.panelDimensions.height);
    //     }else{
    //     }
    //     // height needs to be the visible rows, not infinite scroll
    //
    //     // if(!this.zidx.options.wixApp) {
    //     //     this.options.containerElement.style.height = (this.zidx.windowSize.height - this.containerPosition.top) + "px";
    //     // }
    //     let adjustHeight=$(".zidxSearchContainer", this.zidx.peakidxShadowRoot).height()!+10;//$(".zidxSearchResultsHeader", this.zidx.peakidxShadowRoot).height()!;
    //     this.options.containerElement.style.height = (containerHeight+adjustHeight) + "px";
    //     this.options.panelContainerElement.style.height = containerHeight + "px";
    //     // }
    //     this.panelContainerPosition=this.options.panelContainerElement.getBoundingClientRect();
    //     if(this.options.debug) console.log("panelContainerPosition:", this.panelContainerPosition);
    // }
    // areVisiblePanelsChanged():boolean{
    //     this.getPanelDimensions();
    //     let scrollTop=this.options.containerElement.scrollTop;
    //     if(this.options.debug) console.log("scrollTop:", scrollTop, " this.columnCount:", this.columnCount, " rowHeight:", this.rowHeight);
    //     let minRow=Math.max(0, Math.floor(scrollTop/this.rowHeight));
    //     let maxRow=minRow+Math.ceil(this.containerPosition.height/this.rowHeight)+1;
    //     if(this.options.debug) console.log("this.zidx.windowSize.height", this.zidx.windowSize.height, " containerPosition.top:", this.containerPosition.top, " containerPosition.height:", this.containerPosition.height, " minRow:", minRow, " maxRow:", maxRow);
    //
    //     let newStart=minRow*this.columnCount;
    //     let newEnd=maxRow*this.columnCount;
    //     newEnd=Math.max(newEnd-1, 0);
    //     let changed=false;
    //     if(this.options.enableLoadMore) {
    //         newEnd = this.loadedCount - 1;
    //     }
    //     if(newStart!=this.startVisibleIndex || newEnd!=this.endVisibleIndex){
    //         changed=true;
    //         this.startVisibleIndex=newStart;
    //         this.endVisibleIndex=newEnd;
    //     }
    //     // if(this.options.enableLoadMore){
    //     //     this.startVisibleIndex=0;
    //     //     console.log("loadedCount", this.loadedCount);
    //     //     this.endVisibleIndex=this.loadedCount;
    //     //     return changed;
    //     // }
    //     if(this.options.debug) console.log("startVisibleIndex:", this.startVisibleIndex, " endVisibleIndex:", this.endVisibleIndex);
    //     return changed;
    // }
    firstLoadSetup=true;
    marginPixels:number=0;
    // updatePanelPosition(panel:InfiniteScrollPanel){
    //     // return;
    //     let row=Math.floor(panel.offset/this.columnCount);
    //     let column=Math.floor(panel.offset%this.columnCount);
    //     let columnGapPixels=10;
    //     // if(this.columnCount>1) {
    //     //     columnGapPixels = Math.round(this.marginPixels / (this.columnCount - 1));
    //     // }
    //     let newX=Math.floor((column*this.panelDimensions.width)+(column*columnGapPixels));
    //     let newY=Math.floor(row*this.rowHeight);
    //     // console.log("updatePanelPosition", panel.offset, "row:", row, "column:", column, "newX:", newX, "newY:", newY, "panelDimensions.width:", this.panelDimensions.width, "columnGapPixels:", columnGapPixels);
    //     // console.log("updatePanelPosition", newX, newY);
    //     if(newX!=panel.x || newY!=panel.y) {
    //         panel.x = newX;
    //         panel.y = newY;
    //         panel.element.style.cssFloat="none";
    //         panel.element.style.position="absolute";
    //         panel.element.style.left = Math.round(panel.x) + "px";
    //         panel.element.style.top = Math.round(panel.y) + "px";
    //         if(this.options.debug) console.log("move panel:"+panel.offset+" to left:"+panel.x+" top:"+panel.y);
    //     }
    // }
    destroyPanels(){
        for(let i in this.panels){
            this.panels[i].destroy();
        }
        this.panels=[];
        // this.startVisibleIndex=0;
        // this.endVisibleIndex=0;
    }
    updatePanels(){
        // let newPanels:InfiniteScrollPanel[]=[];
        // for(let i in this.panels){
        //     let panel=this.panels[i];
        //     if(typeof panel=="undefined"){
        //         continue;
        //     }
        //     panel.element.getBoundingClientRect();
        //     if(this.startVisibleIndex>panel.offset || this.endVisibleIndex<panel.offset) {
        //         if(this.options.debug) console.log("destroy panel:", i);
        //         panel.destroy();
        //     }else{
        //         newPanels[panel.offset]=panel;
        //     }
        // }
        // console.log("display panels", "startVisibleIndex", this.startVisibleIndex, "endVisibleIndex", this.endVisibleIndex);
        // return;
        // this.panels=newPanels;
        // this.marginPixels=this.panelContainerPosition.width%this.panelDimensions.width;
        if(this.options.debug) console.log("marginPixels:", this.marginPixels);
        if(this.firstLoadSetup){
            this.firstLoadSetup=false;
            for(let i=0;i<30;i++){
                let div=this.zidx.peakidxShadowRoot.getElementById(this.options.panelClass+i);
                if(div==null) {
                    break;
                }
                let panel = new InfiniteScrollPanel(<HTMLAnchorElement>div);
                panel.offset=i;
                // this.updatePanelPosition(panel);
                panel.rendered=true;
                let $panelElement=$(".zidxImageNotLoaded", panel.element);
                panel.visible=true;
                if($panelElement.length>0) {
                    $($panelElement[0]).attr("style", this.zidx.getListingBackgroundImageCSS($panelElement.attr("data-image")!, true));
                    $panelElement.removeClass("zidxImageNotLoaded");
                }
                this.panels[i]=panel;
            }
        }
        // console.log("updating panels:", Math.min(Math.min(this.resultLimit, this.options.count)-1, this.endVisibleIndex), this.startVisibleIndex, this.endVisibleIndex);
        // console.log("display count:", Math.min(Math.min(this.resultLimit, this.options.count), this.loadedCount), this.resultLimit, this.options.count, this.loadedCount);
        for(let i=0;i<Math.min(Math.min(this.resultLimit, this.options.count), this.loadedCount);i++){
        // for(let i=this.startVisibleIndex;i<=Math.min(Math.min(this.resultLimit, this.options.count)-1, this.endVisibleIndex);i++){
            if(typeof this.panels[i]=="undefined") {
                let div=this.zidx.peakidxShadowRoot.getElementById(this.options.panelClass+i);
                if(div==null) {
                    let newDiv = document.createElement("a");
                    newDiv.className = this.options.panelClass;
                    newDiv.id = this.options.panelClass + i;
                    this.panels[i] = new InfiniteScrollPanel(<HTMLAnchorElement>newDiv);

                    // console.log("infinite panel1", this.panels[i]);
                    this.options.panelContainerElement.appendChild(this.panels[i].element);
                }else{
                    this.panels[i] = new InfiniteScrollPanel(<HTMLAnchorElement>div);
                    // console.log("infinite panel2", this.panels[i]);
                    this.panels[i].rendered=true;
                }
            }
            let panel=this.panels[i];
            panel.offset=i;
            // this.updatePanelPosition(panel);
            // this.updatePanelVisibility(panel);
            if(!panel.rendered) {
                // console.log("called panel render callback for panel offset", panel.offset);
                // @ts-ignore
                this.options.panelCallbackObj[this.options.panelRenderCallback](panel);
            }else{
                // console.log("already rendered panel:"+i);
            }
        }
    }
    resize(){
        // this.getPanelDimensions();
        // this.areVisiblePanelsChanged();
        this.updatePanels();
    }
    panelCount=0;
    setCount(count:number){
        this.panelCount=count;
    }
    update(){
        // check size of panel
        // if(this.areVisiblePanelsChanged()) {
            $(".zidxLoadMoreButton", this.zidx.peakidxShadowRoot).show();
            this.updatePanels();
            // console.log("count check", this.loadedCount, this.panelCount, this.zidx.zidxBase.listingData.totalListings, this.zidx.zidxBase.listingData.listings.length);
            if (this.loadedCount > this.panelCount) {
                $(".zidxLoadMoreButton", this.zidx.peakidxShadowRoot).hide();
            }
        // }
    }
}